import { EditorConfig, isHTMLAnchorElement } from 'lexical';
import { LinkNode, SerializedLinkNode } from '@lexical/link';
import { getUrlTarget } from '@mutiny-pkg/bin-ui/src/utils/url';

export type SerializedCustomLinkNode = SerializedLinkNode;

export class CustomLinkNode extends LinkNode {
  static getType(): string {
    return 'custom-link';
  }

  static clone(node: CustomLinkNode): CustomLinkNode {
    return new CustomLinkNode(
      node.getURL(),
      { rel: node.getRel(), target: node.getTarget(), title: node.getTitle() },
      node.__key,
    );
  }

  static importJSON(serializedNode: SerializedCustomLinkNode): CustomLinkNode {
    return new CustomLinkNode(serializedNode.url).updateFromJSON(serializedNode);
  }

  createDOM(config: EditorConfig): HTMLAnchorElement | HTMLSpanElement {
    const anchor = super.createDOM(config);
    if (isHTMLAnchorElement(anchor)) {
      const target = this.getTarget() ?? getUrlTarget(this.getURL());
      if (target) anchor.target = target;
    }
    return anchor;
  }

  exportJSON(): SerializedCustomLinkNode {
    return {
      ...super.exportJSON(),
      type: 'custom-link',
    };
  }
}
